import { render } from "./PickingOrders.vue?vue&type=template&id=282b756c"
import script from "./PickingOrders.vue?vue&type=script&lang=js"
export * from "./PickingOrders.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__